import Glide from "@glidejs/glide";
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from 'photoswipe/dist/umd/photoswipe.umd.min';
import ObjectPosition from '@vovayatsyuk/photoswipe-object-position/photoswipe-object-position.js';

export default class Gallery {
    slider;
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.gallery'), el => {
			new Gallery(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;

		// in the Neos backend the element information is rendered in a appended script tag
		// since this script is executed after it's evaluation, we can safely remove it
		// to make the slider work properly
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			Array.from(document.querySelectorAll('script[data-neos-nodedata]')).forEach((script) => script.remove())
		}

		const options = {
			peek: 0,
			gap: 0,
			arrows: false,
			rewind: false,
			type: 'carousel',
			startAt: 0,
			perView: 1,
            keyboard: true,
			autoplay: isNeosBackend ? false : 11000,
		};

		this.sliderElement = this.element.querySelector('.glide');
		this.slider = new Glide(this.sliderElement, options);
		this.createBullets(this.element);
		this.slider.mount();

        this.pswpInit();
	}

	createBullets(slider) {
		let bulletCount = slider.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length;
		let bulletWrapper = slider.querySelector('.glide__bullets');

		if (bulletCount > 1) {
			if (bulletWrapper) {
				for (let index = 0; index < bulletCount; index++) {
					const button = document.createElement('button');
					button.className = 'glide__bullet';
					button.setAttribute("data-glide-dir", '=' + index);

					button.addEventListener('click', () => {
						this.slider.go('=' + index);
					});

					bulletWrapper.appendChild(button);
				}
			}
		} else {
			if (bulletWrapper) {
				bulletWrapper.remove();
			}
		}
	}

    pswpInit() {
        const glideLightbox = new PhotoSwipeLightbox({
            gallery: this.element,
            children: 'li:not(.glide__slide--clone) picture',
            loop: true,
            pswpModule: PhotoSwipe
        });
        glideLightbox.init();

        glideLightbox.addFilter('domItemData', (itemData, element) => {
            let imgNode = element.querySelector('img');
            itemData.src = element.dataset.pswpSrc;
            itemData.w = parseInt(element.dataset.pswpWidth);
            itemData.h = parseInt(element.dataset.pswpHeight);
            itemData.msrc = imgNode.src;
            itemData.thumbCropped = true;

            return itemData;
        });
        new ObjectPosition(glideLightbox);

        // temp save of animation duration
        let animationDuration = this.slider.settings.animationDuration;
        let keyboard = this.slider.settings.keyboard;

        // pause while pswp is open if autoplay is enabled
        glideLightbox.on('beforeOpen', () => {
            if (!!this.slider.settings.autoplay) {
                this.slider.pause();
                this.slider.update({animationDuration: 0});
            }

            if (this.slider.settings.keyboard) {
                this.slider.update({keyboard: false});
            }

        });

        // sync with glide
        ['change', 'closingAnimationStart'].forEach(event => {
            glideLightbox.on(event, () => {
                const { pswp } = glideLightbox;
                this.slider.go('=' + pswp.currIndex);
            });
        });

        // set slider props back to initial state when pswp is closing
        glideLightbox.on('closingAnimationStart', () => {
            if (!!this.slider.settings.autoplay) {
                this.slider.play();
                this.slider.update({animationDuration: animationDuration});
            }

            if (this.slider.settings.keyboard) {
                this.slider.update({keyboard: keyboard});
            }
        });
    }
}
